import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ClientLoggingService, LOG_ENDPOINT_PATH } from './client-logging.service';

/**
 * Interceptor that catches HTTP errors and bridges them to the ClientLoggingService.
 */
@Injectable()
export class HttpLogInterceptor implements HttpInterceptor {
  private loggingService = inject(ClientLoggingService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Skip logging for the log bridge itself to avoid infinite loops if it fails
        if (request.url.includes(LOG_ENDPOINT_PATH)) {
          return throwError(() => error);
        }

        // Strip query parameters and fragments for privacy
        const url = request.url.split('?')[0].split('#')[0];
        const message = `API Failure: ${request.method} ${url} - Status: ${error.status} ${error.statusText}`;

        // Log the failure to the backend bridge with explicit context
        this.loggingService.log(
          'ERROR',
          {
            message,
            context: 'HttpLogInterceptor',
          },
          error
        );

        return throwError(() => error);
      })
    );
  }
}
